import { render } from "./InterviewerAutocomplete.vue?vue&type=template&id=5b055a39&scoped=true"
import script from "./InterviewerAutocomplete.vue?vue&type=script&lang=js"
export * from "./InterviewerAutocomplete.vue?vue&type=script&lang=js"

import "./InterviewerAutocomplete.vue?vue&type=style&index=0&id=5b055a39&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b055a39"]])

export default __exports__